var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"py-8 text-sm"},_vm._l((_vm.links),function(ref){
var name = ref.name;
var children = ref.children;
var meta = ref.meta;
return _c('div',{key:name,staticClass:"mb-6"},[_c('side-nav',{attrs:{"link":name,"submenu":children,"meta":meta}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }